import { Routes } from '@angular/router';

import {
  InteractiveTimelineDemoComponent,
} from './interactive-timeline-demo.component';

export const interactiveTimelineRoutes: Routes = [
  {
    path: 'interactive-timeline',
    component: InteractiveTimelineDemoComponent,
  },
];



// WEBPACK FOOTER //
// ./src/app/interactive-timeline/interactive-timeline.routes.ts